module.exports = __webpack_public_path__ + "static/media/LondonBus.3fa53b77.svg";